import React, { Component } from 'react'
import QRCode from 'qrcode.react'
import randomColor from 'randomcolor'
import mockjs from 'mockjs'
import { Row, Col, Menu, Icon, Spin, Modal, Pagination, Button, Popover } from 'antd'
import { Link, Redirect } from 'react-router-dom'
import { app, api, config } from "../../app"
import Slider from "react-slick"
import logo_img from "../../assets/LOGO_1.png"
import asyncComponent from "../../components/asyncComponent"
import NewsDetail from "../../components/NewsDetail"
import utils from "../../utils"

const BarReact = asyncComponent(() => import('../../components/BarEcharts'))  //柱形图组件

const MenuItem = Menu.Item

function loadNode(align) {
    let style = {}
    if (align) style.textAlign = align
    return (<div className="load-example" style={style}><Spin size="large" /></div>)
}

function notNode(text, align) {
    let style = {}
    if (align) style.textAlign = align
    return (
        <div className="no-data" style={style}>
            <Icon type="info-circle" />
            <span className="no-data-text">{text}</span>
        </div>
    )
}

/**
 * 生成职能分布图配置参数
 */
function generatePPEChart(info = []) {
    const categories = [], data = []
    info.forEach((item) => {
        categories.push(item.names)
        data.push(item.count)
    })
    let options = {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            axisTick: {
                show: false,
            },
            axisLabel: {
                interval: 0,
                rotate: 40,
                color: '#888888',
                formatter: (value) => {
                    if (value.length > 6) {
                        return value.substr(0, 5) + '...'
                    }
                    return value
                }
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
            splitLine: {
                show: false
            },//去除网格线
            data: categories
        },
        yAxis: {
            show: false,
            minInterval: 1
        },
        series: [
            {
                name: '人数',
                type: 'bar',
                barWidth: 12,
                label: {
                    normal: {
                        show: true,
                        position: 'top',
                        fontSize: 12,
                        color: '#888888',
                        formatter: '{c}人'
                    }
                },
                itemStyle: {
                    normal: {
                        color: () => randomColor({ luminosity: 'light' })
                    }
                },
                data
            }
        ]
    }
    return options
}

/**
 * 排行榜统计图
 * @param dataInfo
 * @param indexno
 */
function chartOptionSet(dataInfo, teamno) {
    const categories = [], data = []
    dataInfo.forEach((item) => {
        categories.push(item.teamname)
        data.push(item.duration || 0)
    })
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'none'
            }
        },
        xAxis: {
            axisTick: {
                show: false,
            },
            axisLabel: {
                interval: 0,
                rotate: 25,
                color: (item, index) => {
                    if (index >= dataInfo.length) {
                        return '#AFCCE2'
                    }
                    if (dataInfo[index].teamno === teamno) {
                        return '#1890ff'
                    }
                    return '#AFCCE2'
                },
                formatter: (value) => {
                    if (value.length > 6) {
                        return value.substr(0, 5) + '...'
                    }
                    return value
                }
            },
            splitLine: { show: false },//去除网格线
            data: categories,
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
        },
        yAxis: {
            // name: '救援时长（时）',
            axisTick: {
                show: false,
            },
            splitLine: { show: false },//去除网格线
            minInterval: 1,
            nameTextStyle: {
                color: '#666666',
                padding: [0, 10, 10, 0]
            },
            axisLabel: {
                show: true,
                color: '#666'
            },
            axisLine: {
                show: true,
                lineStyle: {
                    color: '#dddddd'
                }
            },
        },
        series: [{
            name: '救援时长',
            type: 'bar',
            data: data,
            barWidth: 12,
            itemStyle: {
                normal: {
                    color: ({ dataIndex }) => {
                        if (dataInfo[dataIndex].teamno === teamno) {
                            return '#1890ff'
                        }
                        return '#AFCCE2'
                    }
                }
            },
            label: {
                normal: {
                    show: true,
                    position: 'top',
                    fontSize: 12,
                    formatter: '{c} 时'
                }
            }
        }]
    }
}

class Team extends Component {
    constructor(props) {
        super(props)
        // console.log(props.history)
        this.state = {
            token: '',
            menu_key: ['information'],
            menus: [
                { key: 'information', name: '队伍信息', content: null },
                { key: 'authorize', name: '注册信息', content: null },
                { key: 'skill', name: '全队职能分布', content: null },
                { key: 'equipment', name: '队伍装备', content: null },
                { key: 'honorwall', name: '荣誉墙', content: null },
                { key: 'news', name: '新闻动态', content: null },
                { key: 'ranking', name: '排行榜', content: null },
                { key: 'train', name: '队务建设及后台经历', content: null },
                { key: 'rescue', name: '救援经历', content: null },
                { key: 'drill', name: '演练及培训经历', content: null },
                { key: 'social', name: '社会服务经历', content: null },
                { key: 'style', name: '队伍风采', content: null },
                { key: 'public', name: '队伍公开', content: null },
                { key: 'dynamic', name: '最新动态', content: null },
            ],
            ppeChart: {},
            info: {
                train: {},
                rescue: {},
                drill: {},
                socialService: {},
                rescueYear: [],
                trainYear: [],
                drillYear: [],
                socialServiceYear: [],
            },
            ppeList: [],
            data_loading: true,
            ppe_loading: true,
            teamno: props.match.params.teamno,
            train_menu_key: '',
            rescue_menu_key: '',
            drill_menu_key: '',
            socialService_menu_key: '',
            experience_loading: false,
            experience_visible: false,
            experience_text: '',
            experience_api: '',
            experience_year: '',
            experience_key: '',
            experienceList: [],
            report_modal_loading: false,
            e_page: 1,
            e_total: 0,
            newsInfo: {},
            news_detail_visible: false,
            news_detail_loading: false,
            chartOptions: {},
            ranking_loading: true,
            has_ranking: false,
            ranking_menu: '2',
            ranking: '-',
            rankingList: [],
            userRanking_visible: false,
            error: false
        }
    }

    async componentDidMount() {
        this._isMounted = true
        this.getTokeni();
        await this.dataSource()
        if (this.state.has_ranking) {
            await this.rankingSource()
        }
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 数据源
     */
    dataSource = async () => {
        let { teamno } = this.state
        let { flag, data, msg } = await app.post(api.TeamDetails, { teamno })
        let state = { data_loading: false }
        if (flag === 1) {
            // data.rescue = { "2018": { total: 0, data: [] }, "2019": { total: 0, data: [] } }
            // data.train = { "2018": { total: 0, data: [] }, "2019": { total: 0, data: [] } }
            // data.drill = { "2018": { total: 0, data: [] }, "2019": { total: 0, data: [] } }
            // data.socialService = { "2018": { total: 0, data: [] }, "2019": { total: 0, data: [] } }
            data.rescueYear = Object.keys(data.rescue)
            data.trainYear = Object.keys(data.train)
            data.drillYear = Object.keys(data.drill)
            data.socialServiceYear = Object.keys(data.socialService)
            state.train_menu_key = data.trainYear[data.trainYear.length - 1]
            state.rescue_menu_key = data.rescueYear[data.rescueYear.length - 1]
            state.drill_menu_key = data.drillYear[data.drillYear.length - 1]
            state.socialService_menu_key = data.socialServiceYear[data.socialServiceYear.length - 1]
            state.ppeChart = generatePPEChart(data.class)
            state.info = data
            if (data.status_id !== '3') {
                state.has_ranking = true
            }
        } else {
            app.alert(msg, "error")
            state.error = true
        }
        await this.setData(state)
    }

    /**
     * 顶部导航栏点击
     */
    handleMenuClick = ({ key }) => {
        if (key) {
            let anchorElement = document.getElementById('mp-' + key)
            if (anchorElement) {
                anchorElement.scrollIntoView(true)
            }
        }
    }

    /**
     * 报表详情查询
     * @returns {Promise<void>}
     */
    reportSource = async (id) => {
        let params = {
            id,
            request: 'reports',
        }, { flag, data, msg } = await app.post(api.ReportsDetails, params)
        if (flag === 1) {
            let { principal, object_volunteer, object_volunteer_rear, is_domestic } = data
            if (is_domestic === '1') {
                data.domestic = '国内'
                data.area = [data.province, data.city, data.region].join(' ')
            } else if (is_domestic === '2') {
                data.domestic = '国外'
            }
            data.principal = (principal ? principal.map(p => p.vname) : []).join('、')
            let ov_vname = [], ovr_vname = []
            for (let i = 0; i < (object_volunteer || []).length; i++) {
                ov_vname.push(object_volunteer[i].vname)
            }
            for (let j = 0; j < (object_volunteer_rear || []).length; j++) {
                ovr_vname.push(object_volunteer_rear[j].vname)
            }
            data.object_volunteer = ov_vname.join('、')
            data.object_volunteer_rear = ovr_vname.join('、')
            return data
        } else {
            app.alert(msg, "error")
            return {}
        }
    }

    /**
     * 排行榜导航栏点击
     */
    handleRankingMenuClick = async ({ key }) => {
        if (key) {
            const state = { ranking_menu: key, ranking_menu_old: '1' }
            if (key === '3') {
                state.ranking_menu_old = this.state.ranking_menu
                state.userRanking_visible = true
            }
            await this.setData(state)
            await this.rankingSource()
        }
    }

    /**
     * 显示报表详情
     * @param id
     */
    handleShowDetail = async (id) => {
        if (this.state.report_modal_loading) return
        app.alert('正在加载...', 'loading', '35%', 0)
        await this.setData({ report_modal_loading: true })
        const data = await this.reportSource(id)
        app.alertDestroy()
        Modal.info({
            title: '详细信息',
            width: '60vw',
            centered: true,
            zIndex: 2999,
            content: (
                <div style={{ height: '60vh', overflow: 'auto' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>账号：</Col>
                        <Col span={14} offset={1}>{data.account || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>创建人：</Col>
                        <Col span={14} offset={1}>{data.vname || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>参与部门：</Col>
                        <Col span={14} offset={1}>{data.department || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务类型：</Col>
                        <Col span={14} offset={1}>{data.type_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务科目：</Col>
                        <Col span={14} offset={1}>{data.subject_name || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务项目名称：</Col>
                        <Col span={14} offset={1}>{data.title || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>相关人：</Col>
                        <Col span={14} offset={1}>{data.relevant || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>报案人：</Col>
                        <Col span={14} offset={1}>{data.reporter || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>报案人联系方式：</Col>
                        <Col span={14} offset={1}>{data.reporter_contact || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务对象：</Col>
                        <Col span={14} offset={1}>{data.request_object || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务对象联系方式：</Col>
                        <Col span={14} offset={1}>{data.request_object_contact || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>首次接触事务时间：</Col>
                        <Col span={14} offset={1}>{data.event_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>救援范围：</Col>
                        <Col span={14} offset={1}>{data.domestic || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>省市区：</Col>
                        <Col span={14} offset={1}>{data.area || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>具体地址：</Col>
                        <Col span={14} offset={1}>{data.address || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>任务负责人/现场指挥：</Col>
                        <Col span={14} offset={1}>{data.principal || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>出队队伍：</Col>
                        <Col span={14} offset={1}>{data.object_teamname || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>现场出队队员：</Col>
                        <Col span={14} offset={1}>{data.object_volunteer || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>后台出队队员：</Col>
                        <Col span={14} offset={1}>{data.object_volunteer_rear || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>出队人数：</Col>
                        <Col span={14} offset={1}>{data.action_people_number || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>出队时间：</Col>
                        <Col span={14} offset={1}>{data.action_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>是否完成：</Col>
                        <Col span={14} offset={1}>{data.whether_succeed === '11' ? '已完成' : '未完成'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>收队时间：</Col>
                        <Col span={14} offset={1}>{data.recruit_time || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>出队车辆数：</Col>
                        <Col span={14} offset={1}>{data.action_car_number || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>车牌号码：</Col>
                        <Col span={14} offset={1}>{data.number_plate || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>其他工具：</Col>
                        <Col span={14} offset={1}>{data.other_tools || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>事件进展：</Col>
                        <Col span={14} offset={1}>{data.event_progress || '-'}</Col>
                    </Row>
                    {/* <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>服务时长/人：</Col>
                        <Col span={14} offset={1}>{data.service_time || '-'}</Col>
                    </Row> */}
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>受益人数：</Col>
                        <Col span={14} offset={1}>{data.benefit_number || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>任务总结：</Col>
                        <Col span={14} offset={1}>{data.task_summary || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>总结人：</Col>
                        <Col span={14} offset={1}>{data.summary_person || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>百度网盘链接：</Col>
                        <Col span={14} offset={1}>{data.web_link || '-'}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6}>事件图片：</Col>
                        <Col span={14} offset={1}>
                            {data.secret === '1' ? '保密任务' : (data.event_img || []).map((ei, index) => {
                                return (
                                    <div key={index}>
                                        <img src={config.imgUrl + ei} style={{
                                            width: 'auto',
                                            height: 'auto',
                                            maxWidth: '100%'
                                        }} alt="" />
                                    </div>
                                )
                            })}
                        </Col>
                    </Row>
                </div>
            ),
        })
        await this.setData({ report_modal_loading: false })
    }

    /**
     * 显示公开详情
     **/
    handlePublicDetail = (info) => {
        Modal.info({
            title: '公开详情',
            width: '60vw',
            centered: true,
            zIndex: 2999,
            content: (
                <div style={{ height: '60vh', overflow: 'auto' }}>
                    <div style={{
                        padding: '10px 0',
                        borderBottom: '1px solid #ddd',
                        fontWeight: 'bolder'
                    }}>【{info.open_class_name}】{info.title}</div>
                    <div style={{ padding: '10px 0' }}>{info.content}</div>
                </div>
            )
        })
    }

    /**
     * 装备详情
     **/
    handleMallDetail = (info) => {
        Modal.info({
            title: '装备详情',
            width: '60vw',
            centered: true,
            zIndex: 2999,
            content: (
                <div style={{ height: '60vh', overflow: 'auto' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备名称</Col>
                        <Col span={14} offset={1}>{info.equip_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备来源</Col>
                        <Col span={14} offset={1}>{info.source_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>装备数量</Col>
                        <Col span={14} offset={1}>{info.equip_num}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>报废数量</Col>
                        <Col span={14} offset={1}>{info.equip_scrapped_num}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>添加时间</Col>
                        <Col span={14} offset={1}>{info.submit_time}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={5}>上次检修日期</Col>
                        <Col span={14} offset={1}>{info.equip_overhaul_time || '-'}</Col>
                    </Row>
                    <div>
                        <div>装备图片</div>
                        <div style={{ height: 200, marginTop: 10 }}>
                            <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                src={config.imgUrl + info.equip_img} alt="" />
                        </div>
                    </div>
                </div>
            ),
        })
    }

    /**
     * 查看新闻详情
     * @param id
     */
    handleNewsDetail = async (id) => {
        await this.setData({ news_detail_visible: true, news_detail_loading: true })
        let state = { news_detail_loading: false }
        let { flag, data, msg } = await app.post(api.NewNewsDetails, {
            id,
            request: 'news',
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        if (flag === 1) {
            data.id = id
            state.newsInfo = data
        } else {
            app.alert(msg, 'error')
        }
        await this.setData(state)
    }

    /**
     * 经历查询
     * @returns {Promise<void>}
     */
    experienceSource = async (page = 1) => {
        await this.setData({ experience_loading: true, e_page: page })
        const { experience_api, teamno, experience_year } = this.state
        let { flag, data, msg, total } = await app.post(experience_api, { teamno, page, year: experience_year })
        if (flag !== 1) {
            data = []
            app.alert(msg, "error")
        }
        if (page === this.state.e_page) {
            await this.setData({
                experience_loading: false,
                experienceList: utils.addArrayKey(data),
                e_total: parseInt(total || 0)
            })
        }
    }

    /**
     * 排行榜查询
     */
    rankingSource = async () => {
        await this.setData({ ranking_loading: true })
        const { ranking_menu, teamno } = this.state, params = {
            type: ranking_menu,
            teamno,
        }
        let { flag, data, msg } = await app.post(api.LTeamRanking, params)
        const state = { ranking_loading: false }
        if (flag === 1) {
            if (ranking_menu === '3') {
                state.rankingList = data.list
            } else {
                state.ranking = (data.ranking || '-') + ''
                state.chartOptions = chartOptionSet(data.list, teamno)
            }
        } else {
            app.alert(msg, "error")
        }
        if (ranking_menu === this.state.ranking_menu) {
            await this.setData(state)
        }
    }

    /**
     * 前往经历列表
     * @param type
     */
    handleToExperience = async (type) => {
        const state = { experience_visible: true, experience_key: type }
        switch (type) {
            case 'train':
                state.experience_text = '队务建设及后台经历'
                state.experience_year = this.state.train_menu_key
                state.experience_api = api.MYearTeamTrainList
                break
            case 'rescue':
                state.experience_text = '救援经历'
                state.experience_api = api.MYearTeamRescueList
                state.experience_year = this.state.rescue_menu_key
                break
            case 'drill':
                state.experience_text = '演练及培训经历'
                state.experience_api = api.MYearTeamDrillList
                state.experience_year = this.state.drill_menu_key
                break
            case 'socialService':
                state.experience_text = '社会服务经历'
                state.experience_api = api.MYearTeamSocialList
                state.experience_year = this.state.socialService_menu_key
                break
        }
        if (state.experience_api) {
            await this.setData(state)
            await this.experienceSource(1)
        }
    }

    /**
     * 关闭经历列表
     */
    handleCloseExperience = async () => {
        await this.setData({
            experience_visible: false,
            experience_text: '',
            experience_api: '',
            experience_year: '',
            experience_key: '',
            experienceList: [],
            e_page: 1,
            e_total: 0,
        })
    }

    /**
     * 跳转队伍页面
     */
    handleToPlayers = () => {
        this.props.history.push(`/ranks/players/${this.state.teamno}`)
    }

    /**
     * 关闭队员排行榜
     */
    handleCloseUserRanking = async () => {
        const state = { userRanking_visible: false, ranking_menu: this.state.ranking_menu_old, ranking_menu_old: '1' }
        await this.setData(state)
        await this.rankingSource()
    }

    /**
* 获取token
* @returns {Promise<void>}
*/
    getTokeni = async () => {
        let { flag, data, msg } = await app.post(api.getToken);
        if (flag === 1) {
            this.setState({
                token: data.token
            });
        } else {
            app.alert(msg, 'warn');
        }
    };

    /**
     * 荣誉墙点击
     * @param honor
     */
    handleHonorClick = async (honor) => {
        Modal.info({
            title: '荣誉详情',
            okText: '确定',
            centered: true,
            width: '50vw',
            content: (
                <div style={{ padding: '20px 0' }}>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉图片：</Col>
                        <Col span={14} offset={1}>
                            <div style={{ height: 120 }}>
                                <img style={{ width: "auto", height: "auto", maxHeight: "100%", maxWidth: "100%" }}
                                    src={config.imgUrl + honor.img} alt="" title={honor.name} />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉名称：</Col>
                        <Col span={14} offset={1}>{honor.name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉类型：</Col>
                        <Col span={14} offset={1}>{honor.type_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>荣誉等级：</Col>
                        <Col span={14} offset={1}>{honor.category_name}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>获奖时间：</Col>
                        <Col span={14} offset={1}>{honor.date}</Col>
                    </Row>
                    <Row style={{ marginBottom: 10 }}>
                        <Col span={6} style={{ textAlign: 'right' }}>备注信息：</Col>
                        <Col span={14} offset={1}><span>{honor.remark || ' - '}</span></Col>
                    </Row>
                </div>
            )
        })
    }

    render() {
        let {
            data_loading, teamno, info, menus, menu_key, train_menu_key, rescue_menu_key, drill_menu_key, socialService_menu_key, ranking, ranking_menu,
            experience_visible, e_page, e_total, experience_text, experienceList, experience_loading, experience_year, experience_key, ppeChart, newsInfo,
            news_detail_visible, news_detail_loading, ranking_loading, chartOptions, has_ranking, userRanking_visible, rankingList, error
        } = this.state
        if (error) {
            return (<Redirect to="/ranks" />)
        }
        let carousel_settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 4,
            initialSlide: 0,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        }
        let menu_nodes = []
        if (!data_loading) {
            menu_nodes = menus.map(m => {
                switch (m.key) {
                    case 'information':
                        m.content = (
                            <Row type="flex" justify="center" align="middle" className="tci-info tci-module">
                                <div className="t-logo">
                                    <img src={logo_img} alt="" />
                                </div>
                                <div className="t-info">
                                    <div className="name">{info.teamname}</div>
                                    <div className="news">
                                        <div className="ti-item">
                                            <div className="ti-title">队长：</div>
                                            <div className="ti-content">
                                                {
                                                    info.teamheader && info.teamheader.length > 0 ? info.teamheader.map((th, i) => (
                                                        <Link key={i} style={{ padding: "0 .25rem" }}
                                                            to={`/player/${info.id}/${th.indexno}?token=${this.state.token}`}>{th.vname}</Link>)) : " - "
                                                }
                                            </div>
                                        </div>
                                        {/* <div className="ti-item">
                                            <div className="ti-title">队伍编号：</div>
                                            <div className="ti-content">{info.teamno}</div>
                                        </div> */}
                                        <div className="ti-item">
                                            <div className="ti-title">队伍人数：</div>
                                            <div className="ti-content">{info.teamCount || '0'}</div>
                                        </div>
                                        <div className="ti-item">
                                            <div className="ti-title">队伍状态：</div>
                                            <div className="ti-content">{info.status || ' - '}</div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    info.status_id === '3' ? (<div className='t-state-img xj-img' />) : null
                                }
                            </Row>
                        )
                        break
                    case 'authorize':
                        let { brand, register } = info
                        brand = brand || {}
                        register = register || {}
                        m.content = (
                            <Row type="flex" justify="center" align="middle" className="tci-authorize">
                                {/*<div className="ta-item">*/}
                                {/*    <i className="iconfont icon-yihuodepinpaishouquan1"*/}
                                {/*       style={{ color: brand.status === "1" ? "#8CC96A" : (brand.status === "2" ? "#EC9A39" : "#CCCCCC") }}/>*/}
                                {/*    <div className="tai-info">*/}
                                {/*        <div className="title">品牌授权信息</div>*/}
                                {/*        {*/}
                                {/*            brand.status === "1" ? (*/}
                                {/*                <div className="state" style={{ color: "#8CC96A" }}>已获取</div>*/}
                                {/*            ) : (brand.status === "2" ? (*/}
                                {/*                <div className="state" style={{ color: "#EC9A39" }}>已过期</div>*/}
                                {/*            ) : (*/}
                                {/*                <div className="state">未获取</div>*/}
                                {/*            ))*/}
                                {/*        }*/}
                                {/*        <div>被授权人: {brand.name || "-"}</div>*/}
                                {/*        <div>授权单位: {brand.authorize_name || "-"}</div>*/}
                                {/*        <div>授权时间: {brand.status ? (brand.authorize_start_time + " ~ " + brand.authorize_end_time) : "-"}</div>*/}
                                {/*    </div>*/}
                                {/*</div>*/}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} className="ta-item">
                                    <i className="iconfont icon-minzhengzhucexinxi1"
                                        style={{ color: register.status === "1" ? "#E38888" : (register.status === "2" ? "#EC9A39" : "#CCCCCC") }} />
                                    <div style={{ marginLeft: '3rem' }} className="tai-info">
                                        <div className="title">法人注册信息</div>
                                        {
                                            register.status === "1" ? (
                                                <div className="state" style={{ color: "#E38888" }}>已获取</div>
                                            ) : (register.status === "2" ? (
                                                <div className="state" style={{ color: "#EC9A39" }}>已过期</div>
                                            ) : (
                                                <div className="state">未获取</div>
                                            ))
                                        }
                                        <div>注册名称: {register.authorize_name || "-"}</div>
                                        <div>法人代表: {register.name || "-"}</div>
                                        <div>信用编码: {register.credit_code || "-"}</div>
                                    </div>
                                </div>
                            </Row>
                        )
                        break
                    case 'skill':
                        m.content = (
                            <div className="tci-skill">
                                <BarReact option={ppeChart} height={300} />
                                <div className="ts-btns">
                                    <Button type="primary" icon="user"
                                        onClick={() => this.handleToPlayers()}>队员列表</Button>
                                </div>
                            </div>
                        )
                        break
                    case 'equipment':
                        m.content = (
                            <div className="tci-equipment">
                                <Slider {...carousel_settings}>
                                    {
                                        info.mall && info.mall.length > 0 ? info.mall.map((m, i) => {
                                            return (
                                                <div key={i + ''} className="pe-item" title={m.equip_name}
                                                    onClick={() => this.handleMallDetail(m)}>
                                                    <div className="pei-img">
                                                        <img
                                                            src={config.imgUrl + m.equip_img}
                                                            alt="装备图片" />
                                                    </div>
                                                    <div className="pei-name" title={m.equip_name}>
                                                        {m.equip_name}
                                                    </div>
                                                </div>
                                            )
                                        }) : notNode('暂未购买装备')
                                    }
                                </Slider>
                                {
                                    info.mall && info.mall.length >= 15 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/equipments/' + teamno}>
                                                <span className="more-link-text">更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'ranking':
                        if (!has_ranking) {
                            m.content = notNode('该队伍已下架，不纳入排行榜')
                            break
                        }
                        let rnfs = 14
                        if (ranking.length > 4) {
                            rnfs = 36
                        } else if (ranking.length > 3) {
                            rnfs = 42
                        } else if (ranking.length > 2) {
                            rnfs = 60
                        } else {
                            rnfs = 68
                        }
                        m.content = (
                            <div className="tci-ranking">
                                <Menu mode="horizontal" className="pr-menu" selectedKeys={[ranking_menu]}
                                    onClick={this.handleRankingMenuClick}>
                                    <MenuItem key="2">省内排行</MenuItem>
                                    <MenuItem key="1">国内排行</MenuItem>
                                    <MenuItem key="3">队员排行</MenuItem>
                                </Menu>
                                <div className="pr-content">
                                    {
                                        ranking_loading ? loadNode() : (
                                            <Row className="prc-info" type="flex" align="middle">
                                                <div className="no">
                                                    <div className="n-no">
                                                        <span style={{ fontSize: rnfs }}>{ranking}</span>
                                                    </div>
                                                    <div>
                                                        {ranking_menu === '1' ? '国内排名' : '省内排名'}
                                                    </div>
                                                </div>
                                                <div className="chart">
                                                    <BarReact option={chartOptions} height={280} />
                                                </div>
                                            </Row>
                                        )
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'honorwall':
                        m.content = (
                            <div className="tci-equipment">
                                <Slider {...carousel_settings}>
                                    {
                                        info.honor && info.honor.length > 0 ? info.honor.map((m, i) => {
                                            return (
                                                <div key={i} className="pe-item" title={m.name}
                                                    onClick={() => this.handleHonorClick(m)}>
                                                    <div className="pei-img" style={{ cursor: 'pointer' }}>
                                                        <img src={config.imgUrl + m.img} alt="荣誉图片" />
                                                    </div>
                                                    <div className="pei-name" title={m.name}>
                                                        {m.name}
                                                    </div>
                                                </div>
                                            )
                                        }) : notNode('暂无荣誉信息')
                                    }
                                </Slider>
                                {
                                    info.honor && info.honor.length >= 15 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/honorwall/' + teamno}>
                                                <span className="more-link-text">更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'train':
                        m.content = (
                            <div className="tci-train tci-module">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[train_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ train_menu_key: key })
                                    }}>
                                    {
                                        info.trainYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.train[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.train[train_menu_key].data.length > 0 ?
                                            info.train[train_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id} onClick={() => this.handleShowDetail(d.id, 'train')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无队务建设及后台经历')
                                    }
                                    {
                                        info.train[train_menu_key].data.length >= 4 ? (
                                            <div className="more-link" onClick={() => this.handleToExperience('train')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>

                            </div>
                        )
                        break
                    case 'rescue':
                        m.content = (
                            <div className="tci-train tci-module">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[rescue_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ rescue_menu_key: key })
                                    }}>
                                    {
                                        info.rescueYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.rescue[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.rescue[rescue_menu_key].data.length > 0 ?
                                            info.rescue[rescue_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id}
                                                        onClick={() => this.handleShowDetail(d.id, 'rescue')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无救援经历')
                                    }
                                    {
                                        info.rescue[rescue_menu_key].data.length >= 4 ? (
                                            <div className="more-link"
                                                onClick={() => this.handleToExperience('rescue')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'drill':
                        m.content = (
                            <div className="tci-train tci-module">
                                <Menu mode="horizontal" className="pt-menu" defaultSelectedKeys={[drill_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ drill_menu_key: key })
                                    }}>
                                    {
                                        info.drillYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.drill[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.drill[drill_menu_key].data.length > 0 ?
                                            info.drill[drill_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id} onClick={() => this.handleShowDetail(d.id, 'drill')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无演练及培训经历')
                                    }
                                    {
                                        info.drill[drill_menu_key].data.length >= 4 ? (
                                            <div className="more-link" onClick={() => this.handleToExperience('drill')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'social':
                        m.content = (
                            <div className="tci-train tci-module">
                                <Menu mode="horizontal" className="pt-menu"
                                    defaultSelectedKeys={[socialService_menu_key]}
                                    onClick={({ key }) => {
                                        this.setData({ socialService_menu_key: key })
                                    }}>
                                    {
                                        info.socialServiceYear.map(ty => {
                                            return (
                                                <MenuItem key={ty} className="ptm-menu">
                                                    <div className="ptm-ci">
                                                        <span className="val">{info.socialService[ty].total}</span>
                                                        <span>次</span>
                                                    </div>
                                                    <div className="ptm-name">{ty}年</div>
                                                </MenuItem>
                                            )
                                        })
                                    }
                                </Menu>
                                <div className="pt-items">
                                    {
                                        info.socialService[socialService_menu_key].data.length > 0 ?
                                            info.socialService[socialService_menu_key].data.map(d => {
                                                return (
                                                    <Row key={d.id}
                                                        onClick={() => this.handleShowDetail(d.id, 'socialService')}
                                                        className="pti-item">
                                                        <Col span={12} className="ptii-name">{d.title}</Col>
                                                        <Col span={12}
                                                            className="ptii-date">{d.action_time} ~ {d.recruit_time}</Col>
                                                    </Row>
                                                )
                                            }) : notNode('暂无社会服务经历')
                                    }
                                    {
                                        info.socialService[socialService_menu_key].data.length >= 4 ? (
                                            <div className="more-link"
                                                onClick={() => this.handleToExperience('socialService')}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>
                        )
                        break
                    case 'style':
                        m.content = (
                            <div className="tci-equipment">
                                {
                                    info.style && info.style.length > 0 ? (
                                        <Slider {...carousel_settings}>
                                            {
                                                info.style.map((s, i) => {
                                                    return (
                                                        <Link to={'/ranks/mien/detail/' + s.id} key={i}
                                                            title={s.style_title}>
                                                            <div key={i + ''} className="pe-item">
                                                                <div className="pei-img">
                                                                    <img
                                                                        src={config.imgUrl + s.style_img}
                                                                        alt="风采图片" />
                                                                </div>
                                                                <div className="pei-name">
                                                                    {s.style_title}
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    )
                                                })
                                            }
                                        </Slider>
                                    ) : notNode('暂无风采内容')
                                }
                                {
                                    info.style && info.style.length >= 15 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/mien/' + teamno}>
                                                <span className="more-link-text">更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'dynamic':
                        m.content = (
                            <div className="tci-dynamic tci-module">
                                {
                                    info.dynamics && info.dynamics.length > 0 ? info.dynamics.map((d, i) => {
                                        return (
                                            <Row className="td-item" key={i}>
                                                <Col span={16} className='name2' title={d.content}>{d.content}</Col>
                                                <Col span={8} className='date'>{d.submit_time}</Col>
                                            </Row>
                                        )
                                    }) : notNode('暂无动态内容')
                                }
                                {
                                    info.dynamics && info.dynamics.length >= 4 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/dynamic/' + teamno}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'public':
                        m.content = (
                            <div className="tci-dynamic tci-module">
                                {
                                    info.open && info.open.length > 0 ? info.open.map((o, i) => {
                                        let title = `【${o.open_class_name}】${o.title}`
                                        return (
                                            <Row className="td-item" key={i}>
                                                <Col span={16} className='name' title={title}
                                                    onClick={() => this.handlePublicDetail(o)}>{title}</Col>
                                                <Col span={8} className='date'>{o.submit_time}</Col>
                                            </Row>
                                        )
                                    }) : notNode('暂无公开内容')
                                }
                                {
                                    info.open && info.open.length >= 4 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/public/' + teamno}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break
                    case 'news':
                        m.content = (
                            <div className="tci-news tci-module">
                                {
                                    info.news && info.news.length > 0 ? info.news.map(item => {
                                        return (<div className="tn-item" key={item.id}
                                            onClick={() => this.handleNewsDetail(item.id)}
                                        >
                                            <div className="tn-img">
                                                <img src={config.imgUrl + item.news_img} alt="" />
                                            </div>
                                            <div className="tn-info">
                                                <div className="tn-title">{item.news_title}</div>
                                                <div className="tn-date">
                                                    <span>{item.release_time}</span>
                                                    <div className="tn-icon">
                                                        <span>
                                                            <i className="iconfont icon-yuedu" style={{ fontSize: '.6rem' }} />
                                                            <span style={{ padding: '0 .25rem' }}>{item.hits || 0}</span>
                                                        </span>
                                                        <Popover placement="right" title="手机扫码分享" content={
                                                            <QRCode value={config.shareDoman + item.id} />
                                                        } overlayStyle={{ textAlign: 'center' }}>
                                                            <span style={{ marginLeft: '.25rem' }}>
                                                                <i className="iconfont icon-fenxiang"
                                                                    style={{
                                                                        fontSize: '.6rem',
                                                                        color: '#5E92B4'
                                                                    }} />
                                                                <span style={{ padding: '0 .25rem' }}>分享</span>
                                                            </span>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)
                                    }) : notNode('暂无新闻')
                                }
                                {
                                    info.news && info.news.length >= 4 ? (
                                        <div className="more-link">
                                            <Link className="link" to={'/ranks/teamnews/' + teamno}>
                                                <span className="more-link-text">查看更多</span>
                                                <Icon type="double-right" />
                                            </Link>
                                        </div>
                                    ) : null
                                }
                            </div>
                        )
                        break

                }
                return m
            })
        }
        return (
            <div className="team-page">
                <Menu mode="horizontal" className="tp-menu" defaultSelectedKeys={menu_key}
                    onClick={this.handleMenuClick}>
                    {
                        menus.map(m => {
                            return (
                                <MenuItem key={m.key}>{m.name}</MenuItem>
                            )
                        })
                    }
                </Menu>
                <div className="tp-scroll">
                    <div className="tps-content">
                        <div style={{ textAlign: 'right', paddingTop: 10 }}>
                            <Button icon="rollback" onClick={() => app.backPage(this)}>返回</Button>
                        </div>
                        {
                            data_loading ? loadNode() : menu_nodes.map((m, i) => {
                                return (
                                    <div key={i} className="tc-item" id={'mp-' + m.key}>
                                        <div className="tci-title">{m.name}</div>
                                        <div className="tci-content">
                                            {m.content}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
                <Modal
                    visible={experience_visible}
                    footer={null}
                    title={info.vname + experience_year + '年' + experience_text}
                    maskClosable={false}
                    centered={true}
                    width='80vw'
                    bodyStyle={{ height: 'calc(80vh - 55px)', overflow: 'auto' }}
                    zIndex={1010}
                    onCancel={this.handleCloseExperience}
                    className="member-experience-modal-class"
                >
                    <div className="e-items">
                        {
                            experience_loading ? loadNode() : experienceList.map((e, i) => {
                                return (
                                    <Row key={i} className="ei-item"
                                        onClick={() => this.handleShowDetail(e.id, experience_key)}>
                                        <Col span={14} className="name">{e.title}</Col>
                                        <Col span={10}
                                            className="date">{e.action_time + (e.recruit_time ? ` ~ ${e.recruit_time}` : '')}</Col>
                                    </Row>
                                )
                            })
                        }
                    </div>
                    <div className="e-page">
                        <Pagination current={e_page} size="small" pageSize={20} total={e_total} hideOnSinglePage={true}
                            onChange={this.experienceSource} />
                    </div>
                </Modal>
                <Modal
                    visible={news_detail_visible}
                    footer={null}
                    title="新闻详情"
                    maskClosable={false}
                    width='100%'
                    style={{ top: 0, height: '100vh' }}
                    bodyStyle={{ height: 'calc(100vh - 55px)', overflow: 'auto' }}
                    onCancel={() => this.setData({ news_detail_visible: false })}
                    zIndex={2999}
                    className="news-detail-modal-class"
                >
                    <NewsDetail data={newsInfo} loading={news_detail_loading} />
                </Modal>
                <Modal
                    visible={experience_visible}
                    footer={null}
                    title={info.teamname + experience_year + '年' + experience_text}
                    maskClosable={false}
                    centered={true}
                    width='80vw'
                    bodyStyle={{ height: 'calc(80vh - 55px)', overflow: 'auto' }}
                    zIndex={1010}
                    onCancel={this.handleCloseExperience}
                    className="member-experience-modal-class"
                >
                    <div className="e-items">
                        {
                            experience_loading ? loadNode() : experienceList.map((e, i) => {
                                return (
                                    <Row key={i} className="ei-item"
                                        onClick={() => this.handleShowDetail(e.id, experience_key)}>
                                        <Col span={14} className="name">{e.title}</Col>
                                        <Col span={10}
                                            className="date">{e.action_time + (e.recruit_time ? ` ~ ${e.recruit_time}` : '')}</Col>
                                    </Row>
                                )
                            })
                        }
                    </div>
                    <div className="e-page">
                        <Pagination current={e_page} size="small" pageSize={20} total={e_total} hideOnSinglePage={true}
                            onChange={this.experienceSource} />
                    </div>
                </Modal>
                <Modal
                    visible={userRanking_visible}
                    footer={null}
                    title={info.teamname + " —— 队员排行"}
                    maskClosable={false}
                    centered={true}
                    width='60vw'
                    bodyStyle={{ height: 'calc(80vh - 55px)', overflow: 'auto' }}
                    zIndex={1010}
                    onCancel={this.handleCloseUserRanking}
                    className="member-userranking-modal-class"
                >
                    <div className="ur-items">
                        {
                            ranking_loading ? loadNode('center') :
                                rankingList.length > 0 ? rankingList.map((ur, i) => {
                                    return (
                                        <div key={i} className="ur-item">
                                            <span className="ranking">{ur.ranking}</span>
                                            <span className="name">{ur.vname}（{ur.bsrno}）</span>
                                            <span className="duration">总服务 <b>{ur.duration || '0'}</b> 时</span>
                                        </div>
                                    )
                                }) : notNode('该队伍暂无队员', 'center')
                        }
                    </div>
                </Modal>
            </div>
        )
    }
}

export default Team



// WEBPACK FOOTER //
// ./src/routes/ranks/Team.jsx